/** Zone codes `@shopify/address` returns that Peerspace does not accept. */
const ZONE_EXCEPTION_CODES: readonly string[] = ["BFP"];

export { ZONE_EXCEPTION_CODES };
